var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	19427: {
		fallback: () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(1340)]).then(() => (() => (__webpack_require__(31340))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	12090: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(9427), __webpack_require__.e(2260), __webpack_require__.e(2076), __webpack_require__.e(9460)]).then(() => (() => (__webpack_require__(49460))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	34288: {
		fallback: () => (Promise.all([__webpack_require__.e(9427), __webpack_require__.e(1352)]).then(() => (() => (__webpack_require__(21352))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	39241: {
		fallback: () => (Promise.all([__webpack_require__.e(9753), __webpack_require__.e(1020)]).then(() => (() => (__webpack_require__(41020))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12.19.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/auth",

	},
	64506: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(4288), __webpack_require__.e(4456)]).then(() => (() => (__webpack_require__(34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	43357: {
		fallback: () => (Promise.all([__webpack_require__.e(3784), __webpack_require__.e(4967), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	63784: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(9427), __webpack_require__.e(6613)]).then(() => (() => (__webpack_require__(16613))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	44803: {
		fallback: () => (__webpack_require__.e(9645).then(() => (() => (__webpack_require__(49645))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.11.7",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "dayjs",

	},
	83835: {
		fallback: () => (__webpack_require__.e(5098).then(() => (() => (__webpack_require__(25098))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.4.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "graphql-request",

	},
	97250: {
		fallback: () => (__webpack_require__.e(6227).then(() => (() => (__webpack_require__(46227))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^4.17.21",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lodash",

	},
	13941: {
		fallback: () => (__webpack_require__.e(3803).then(() => (() => (__webpack_require__(53803))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^14.0.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "uuid",

	},
	79892: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(4288), __webpack_require__.e(3357), __webpack_require__.e(7415)]).then(() => (() => (__webpack_require__(17415))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	99460: {
		fallback: () => (Promise.all([__webpack_require__.e(4705), __webpack_require__.e(9241), __webpack_require__.e(4506), __webpack_require__.e(8069), __webpack_require__.e(5704), __webpack_require__.e(2859)]).then(() => (() => (__webpack_require__(62859))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@core-hr/utility/angular",

	},
	42167: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(4523)]).then(() => (() => (__webpack_require__(74523))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng2-charts",

	},
	48361: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(3357), __webpack_require__.e(3784), __webpack_require__.e(2167), __webpack_require__.e(7424)]).then(() => (() => (__webpack_require__(77424))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@pathos/pathoslogos-ui",

	},
	76136: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(4288), __webpack_require__.e(4705), __webpack_require__.e(9241), __webpack_require__.e(4506), __webpack_require__.e(8069), __webpack_require__.e(8361), __webpack_require__.e(925)]).then(() => (() => (__webpack_require__(80925))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@core-hr/shared",

	},
	21254: {
		fallback: () => (Promise.all([__webpack_require__.e(4967), __webpack_require__.e(8274), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(43835))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser/animations",

	},
	73948: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(4705), __webpack_require__.e(5704), __webpack_require__.e(8400)]).then(() => (() => (__webpack_require__(38400))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@core-hr/com/sdk",

	},
	55524: {
		fallback: () => (__webpack_require__.e(4518).then(() => (() => (__webpack_require__(24518))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.323.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@newrelic/browser-agent/features/logging",

	},
	60455: {
		fallback: () => (Promise.all([__webpack_require__.e(4518), __webpack_require__.e(2076), __webpack_require__.e(7149)]).then(() => (() => (__webpack_require__(47149))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.323.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@newrelic/browser-agent/loaders/browser-agent",

	},
	77399: {
		fallback: () => (Promise.all([__webpack_require__.e(7141), __webpack_require__.e(3620)]).then(() => (() => (__webpack_require__(23620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	98272: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	8890: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	68274: {
		fallback: () => (__webpack_require__.e(6596).then(() => (() => (__webpack_require__(26596))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	},
	74705: {
		fallback: () => (Promise.all([__webpack_require__.e(9753), __webpack_require__.e(7893)]).then(() => (() => (__webpack_require__(97893))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12.19.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/firestore",

	},
	15704: {
		fallback: () => (Promise.all([__webpack_require__.e(7399), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(12484))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxfire/firestore",

	},
	96789: {
		fallback: () => (Promise.all([__webpack_require__.e(9753), __webpack_require__.e(6725)]).then(() => (() => (__webpack_require__(36725))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12.19.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/app",

	},
	46153: {
		fallback: () => (Promise.all([__webpack_require__.e(9753), __webpack_require__.e(5360)]).then(() => (() => (__webpack_require__(45360))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12.19.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/functions",

	},
	52713: {
		fallback: () => (Promise.all([__webpack_require__.e(9753), __webpack_require__.e(7590)]).then(() => (() => (__webpack_require__(67590))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12.19.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/remote-config",

	},
	82455: {
		fallback: () => (__webpack_require__.e(8317).then(() => (() => (__webpack_require__(8317))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "encoding-japanese",

	},
	22087: {
		fallback: () => (__webpack_require__.e(5841).then(() => (() => (__webpack_require__(85841))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^2.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "file-saver",

	},
	29574: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(50659))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.1.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxfire/auth",

	},
	78587: {
		fallback: () => (Promise.all([__webpack_require__.e(9753), __webpack_require__.e(4164)]).then(() => (() => (__webpack_require__(74164))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12.19.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/app-check",

	},
	28105: {
		fallback: () => (Promise.all([__webpack_require__.e(9753), __webpack_require__.e(2969)]).then(() => (() => (__webpack_require__(52969))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12.19.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "firebase/storage",

	},
	24050: {
		fallback: () => (Promise.all([__webpack_require__.e(2260), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.25",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"807": [
		21254,
		73948,
		55524,
		60455
	],
	"925": [
		82455,
		22087,
		29574
	],
	"2090": [
		12090
	],
	"2167": [
		42167
	],
	"2260": [
		98272,
		8890
	],
	"2859": [
		78587,
		28105
	],
	"3357": [
		43357
	],
	"3575": [
		44803,
		83835,
		97250,
		13941
	],
	"3784": [
		63784
	],
	"4288": [
		34288
	],
	"4506": [
		64506
	],
	"4705": [
		74705
	],
	"5704": [
		15704
	],
	"6136": [
		76136
	],
	"7399": [
		77399
	],
	"7424": [
		24050
	],
	"8069": [
		96789,
		46153,
		52713
	],
	"8274": [
		68274
	],
	"8361": [
		48361
	],
	"9180": [
		99460
	],
	"9241": [
		39241
	],
	"9427": [
		19427
	],
	"9892": [
		79892
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}